import {
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewContainerRef,
} from "@angular/core";
import { MatButton } from "@angular/material/button";
import { ThemePalette } from "@angular/material/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Directive({
  selector: `
    button[mat-button][appLoading],
    button[mat-raised-button][appLoading],
    button[mat-icon-button][appLoading],
    button[mat-fab][appLoading],
    button[mat-mini-fab][appLoading],
    button[mat-stroked-button][appLoading],
    button[mat-flat-button][appLoading]
  `,
})
export class ButtonLoadingDirective implements OnChanges {
  constructor(
    private matButton: MatButton,
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2
  ) {
    this.spinnerFactory =
      this.componentFactoryResolver.resolveComponentFactory(MatProgressSpinner);
  }

  @Input() appLoading: boolean;

  @Input() disabled: boolean;

  @Input() color: ThemePalette;

  get nativeElement(): HTMLElement {
    return this.matButton._elementRef.nativeElement;
  }

  private spinnerFactory: ComponentFactory<MatProgressSpinner>;
  private spinner: ComponentRef<MatProgressSpinner>;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.appLoading) {
      return;
    }

    if (changes.appLoading.currentValue) {
      this.nativeElement.classList.add("mat-loading");
      this.matButton.disabled = true;
      this.createSpinner();
    } else if (!changes.appLoading.firstChange) {
      this.nativeElement.classList.remove("mat-loading");
      this.matButton.disabled = this.disabled;
      this.destroySpinner();
    }
  }

  private createSpinner(): void {
    if (!this.spinner) {
      this.spinner = this.viewContainerRef.createComponent(this.spinnerFactory);
      this.spinner.instance.color = this.color;
      this.spinner.instance.diameter = 20;
      this.spinner.instance.mode = "indeterminate";
      this.renderer.appendChild(
        this.nativeElement,
        this.spinner.instance._elementRef.nativeElement
      );
    }
  }

  private destroySpinner(): void {
    if (this.spinner) {
      this.spinner.destroy();
      this.spinner = null;
    }
  }
}
